import { RewardType } from "types/business/RewardType";
import { BehaviorSubject } from "types/libReplace/BehaviorSubject";
import { createUseDefaultObservable } from "utils/libExtend/createUseDefaultObservable";

type CurrentType = RewardType | null;

export const useDefaultObservableRewardTypeNull = createUseDefaultObservable<CurrentType>();

export class BehaviorSubjectRewardTypeNull extends BehaviorSubject<CurrentType> {}
